import React from "react";
import { useTranslation } from "react-i18next";
import "./ProfileCards.css";

import MainButton from "../Elements/MainButton/MainButton";
import SecondButton from "../Elements/SecondButton/SecondButton";

import userIcon from "../../assets/icons/data/user.png";
import lockIcon from "../../assets/icons/auth/forms/lock_primary.png";

const UserSummaryCard = ({ user, onEdit, onDelete, onManageTwoFactor, twoFactorMethod }) => {
  const { t } = useTranslation();
  const emailDomain = user?.email?.trim().toLowerCase().split("@").pop();
  const isApplePrivateRelayEmail = emailDomain === "privaterelay.appleid.com";

  const getTwoFactorLabel = () => {
    if (twoFactorMethod === "app") return t("profile.twoFactorEnabledApp", "2FA enabled (app)");
    if (twoFactorMethod === "email") return t("profile.twoFactorEnabledEmail", "2FA enabled (email)");
    return t("profile.twoFactorDisabled", "2FA disabled");
  };

  return (
    <section className="summary-card summary-card--user">
      <div className="summary-user-top">
        <div className="summary-left">
          <div className="avatar-circle">
            <img src={userIcon} alt="User avatar" className="avatar-icon" />
          </div>

          <div className="summary-text">
            <p className="summary-name">{user.name}</p>
            <p className="summary-email">{user.email}</p>
            <p className="summary-role">{user.role}</p>
          </div>
        </div>

        {!isApplePrivateRelayEmail && (
          <button
            type="button"
            className="summary-security-button"
            onClick={onManageTwoFactor}
            aria-label={t("profile.manageTwoFactor", "Manage two-factor authentication")}
            title={getTwoFactorLabel()}
          >
            <img src={lockIcon} alt="" className="summary-security-button__icon" />
            <span className="summary-security-button__text">2FA</span>
          </button>
        )}
      </div>

      <div className="summary-actions">
        <SecondButton className="summary-btn summary-btn--danger" onClick={onDelete}>
          {t("common.delete") || "Delete"}
        </SecondButton>
        <MainButton className="summary-btn summary-btn--primary" onClick={onEdit}>
          {t("common.edit") || "Edit"}
        </MainButton>
      </div>
    </section>
  );
};

export default UserSummaryCard;
